'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.jsx = exports.h = exports.StateStore = exports.StateController = exports.ProxyComponent = exports.ControlledComponent = exports.ComponentUtils = exports.Component = undefined;

var _component = require('./component');

var _component2 = _interopRequireDefault(_component);

var _componentUtils = require('./component-utils');

var _componentUtils2 = _interopRequireDefault(_componentUtils);

var _domPatcher = require('./dom-patcher');

var _snabbdomJsxLite = require('snabbdom-jsx-lite');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Entry point for Panel apps and components
 * @module panel
 * @example
 * import { Component } from 'panel';
 * customElements.define('my-widget', class extends Component {
 *   // app definition
 * });
 */

var ControlledComponent = _componentUtils2.default.ControlledComponent,
    ProxyComponent = _componentUtils2.default.ProxyComponent,
    StateController = _componentUtils2.default.StateController,
    StateStore = _componentUtils2.default.StateStore;
exports.Component = _component2.default;
exports.ComponentUtils = _componentUtils2.default;
exports.ControlledComponent = ControlledComponent;
exports.ProxyComponent = ProxyComponent;
exports.StateController = StateController;
exports.StateStore = StateStore;
exports.h = _domPatcher.h;
exports.jsx = _snabbdomJsxLite.jsx;